import "./NavLinks.scss";

import React, { memo } from "react";
import { NavLink } from "react-router-dom";

interface IProps {
  linkData: { to: string; title: string }[];
}

const NavLinks: React.FC<IProps> = memo(linkData => {
  return (
    <div className="nav-tabs d-flex align-items-center justify-content-start">
      {linkData.linkData.map(link => {
        return (
          <NavLink key={link.to} to={link.to}>
            {link.title}
          </NavLink>
        );
      })}
    </div>
  );
});

export { NavLinks };
